import { Component } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { ProductCreateWfoodcostProviderPricePage } from "../product-create-wfoodcost-provider-price/product-create-wfoodcost-provider-price";
import { ProvidersServices } from "../../../../providers/services";
import { Globals } from "../../../../../globals";
import { TranslateService } from '@ngx-translate/core';
import * as firebase from 'firebase';
import { AdsServices } from '../../../../ads/services';
import { ProductsServices } from '../../../services';
import { StockListPage } from '../../../../stock/stock-list/stock-list';

/**
 * Generated class for the ProductCreateWfoodcostSelectProviderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-product-create-wfoodcost-select-provider',
  templateUrl: 'product-create-wfoodcost-select-provider.html',
})
export class ProductCreateWfoodcostSelectProviderPage {

  update_state: boolean = false;
  product_uid: string;
  products: any;
  foodcost: any;
  foodcost_parts: number;
  foodcost_static: number;
  product_measurement: any;
  product_name: any;
  product: any;
  firestore: any;
  selected_collapse: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public providersServices: ProvidersServices,
    public globals: Globals,
    public toastCtrl: ToastController,
    public translate: TranslateService,
    public adsServices: AdsServices,
    private alertCtrl: AlertController,
    public productsServices: ProductsServices,) {

    this.firestore = firebase.firestore();
    //this.dish_uid = this.navParams.get('dish_uid');
    this.update_state = this.navParams.get('update_state');
    this.product_uid = this.navParams.get('product_uid');
    this.products = this.navParams.get('products');
    this.product_measurement = this.navParams.get('product_measurement');
    this.product_name = this.navParams.get('product_name');
    this.product = this.navParams.get('product');
  }

  ionViewCanLeave(): Promise<void> {
    return new Promise((resolve, reject) => {
      //Si el show_alert es true i no estem fen un update al plat
      if (this.productsServices.show_alert_delete && !this.update_state) {
        let alert = this.alertCtrl.create({
          title: this.translate.instant('general-atencion'),
          message: this.translate.instant('general-salir-proceso-creacion'),
          subTitle: this.translate.instant('general-se-eliminara-elemento'),
          buttons: [
            {
              text: this.translate.instant('general-no'),
              role: 'cancel',
              handler: () => {
                this.globals.side_menu_active = 'stock';
                reject();
              },
            },
            {
              text: this.translate.instant('general-si'),
              handler: () => {
                this.productsServices.afs.collection('products').doc(this.product_uid).delete();
                resolve();
                this.navCtrl.setRoot(StockListPage);
              },
            },
          ],
        });
        alert.present();
      } else {
        resolve();
      }
    });
  }

  async openProductProviderPrice() {
    this.productsServices.show_alert_delete = false;
    var pred = false;
    if (this.providersServices.providers_array_tmp.length > 0) {

      if (this.update_state) {
        this.globals.GAtrackView('Products', 'Products - Select providers - Update', this.globals.restaurant.email, 'Create/Update', 'Update select providers', 'Products', this.product_name);
      } else {
        this.globals.GAtrackView('Products', 'Products - Select providers - Create', this.globals.restaurant.email, 'Create/Update', 'Create select providers', 'Products', this.product_name);
      }

      for (let provider of this.providersServices.providers_array_tmp) {
        //Si el proveedor viene de ads
        if (provider.ads_provider_uid) {
          //Buscamos si este proveedor ya esta añadido
          await this.adsServices.searchProvider(provider);
          //Si no esta añadido lo añadimos a proveedores
          if (!this.adsServices.provider_exist) {
            await this.adsServices.addProvider(provider);
          }
        }
        if (provider[10] == true) {
          var extra = {
            "product_name": this.product_name,
            "email": provider[8],
            "address": provider[3],
            "nif": provider[2],
          };
          this.globals.dataSet('product_provider', provider[1], '', JSON.stringify(extra));
          //
          pred = true;
          this.navCtrl.push(ProductCreateWfoodcostProviderPricePage, {
            product_measurement: this.product_measurement,
            products: this.products,
            product_uid: this.product_uid,
            update_state: this.update_state,
            product_name: this.product_name,
            product: this.product,
          });

        }
      }

      if (pred == false) {
        let toast = this.toastCtrl.create({
          message: this.translate.instant('instant-selecciona-proveedor-predeterminado'),
          duration: 3000,
          position: 'bottom'
        });
        toast.present();
      }

    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-selecciona-proveedor'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  async ionViewWillEnter() {
    this.providersServices.getPagesProvider(false);

    if (this.update_state) {
      if (this.products != null) {
        if (Object.keys(this.products).length > 0) {
          this.providersServices.providers_array_tmp = Array(); //Reiniciamos array para no tener los antiguos valores.
          if (this.products.providers != undefined) {
            for (let entry of this.products.providers) {
              //Recuperamos los valores del providers a tratar
              await this.providersServices.firestore.collection('providers').doc(entry.uid).get().then(doc => {
                var v = doc.data();
                var _array = Array();
                _array.push(entry.uid);
                _array.push(v.name);
                _array.push(v.nif);
                _array.push(v.address);
                _array.push(v.province);
                _array.push(v.city);
                _array.push(v.phone);
                _array.push(v.country);
                _array.push(v.email);
                _array.push(v.contact_name);
                _array.push(entry.default);//default
                _array.push(entry.price_static);//price_notax
                _array.push(entry.tax_static);//tax
                _array.push(entry.pricetotal_static);//price
                this.providersServices.providers_array_tmp.push(_array);
              });
              const providersRef = this.firestore.collection('providers');
              //Buscamos por ads_provider_uid para los proveedores que son añadidos desde ads
              providersRef.where('UID_RESTAURANT', '==', this.globals.restaurant_uid).where('ads_provider_uid', '==', entry.uid).get()
                .then(snapshot => {
                  snapshot.forEach(doc => {
                    var v = doc.data();
                    var _array = Array();
                    _array.push(entry.uid);
                    _array.push(v.name);
                    _array.push(v.nif);
                    _array.push(v.address);
                    _array.push(v.province);
                    _array.push(v.city);
                    _array.push(v.phone);
                    _array.push(v.country);
                    _array.push(v.email);
                    _array.push(v.contact_name);
                    _array.push(entry.default);//default
                    _array.push(entry.price_static);//price_notax
                    _array.push(entry.tax_static);//tax
                    _array.push(entry.pricetotal_static);//price
                    this.providersServices.providers_array_tmp.push(_array);
                  });
                });
            }
          }
        }
      }
    } else {
      this.products = Array();
      this.providersServices.providers_array_tmp = Array();
      //insert
      var _array = Array();
      _array.push(this.globals.no_provider.UID);
      _array.push(this.globals.no_provider.name);
      _array.push(this.globals.no_provider.nif);
      _array.push(this.globals.no_provider.address);
      _array.push(this.globals.no_provider.province);
      _array.push(this.globals.no_provider.city);
      _array.push(this.globals.no_provider.phone);
      _array.push(this.globals.no_provider.country);
      _array.push(this.globals.no_provider.email);
      _array.push(this.globals.no_provider.contact_name);
      _array.push(true);//default
      _array.push(0);//price_notax
      _array.push(0);//tax
      _array.push(0);//price
      this.providersServices.providers_array_tmp.push(_array);
    }
    this.providersServices.providers_array_tmp = [...this.providersServices.providers_array_tmp];
  }

  collapse() {
    this.selected_collapse = !this.selected_collapse;
  }
}



// WEBPACK FOOTER //
// ./src/pages/products/product-create/product-create-without-foodcost/product-create-wfoodcost-select-provider/product-create-wfoodcost-select-provider.ts